import React from 'react';
import {
  fetchUtils, Filter, BooleanInput, required, Toolbar, SaveButton, DateField, Edit, Create, List, Datagrid, TextField,
  TextInput, SimpleForm, BooleanField, Button
} from 'react-admin';
import DataTable from 'react-data-table-component';
import CloudDownload from '@material-ui/icons/CloudDownload';
import SearchIcon from '@material-ui/icons/Search';
import LanguageIcon from '@material-ui/icons/Language';
import { makeStyles } from '@material-ui/core/styles';
const dataSupport = require('./components/data_support.js');


const useStyles = makeStyles({
  truncatedList: {
    maxWidth: '300px',
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: 'block'
  }
});

const fetch = fetchUtils.fetchJson;
const BASE_URL = window.nobid_endpoint + '/page_search';

const SegmentTitle = ({ record }) => {
  return <span>Segment {record ? `"${record.name}"` : ''}</span>;
};
const SegmentFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
        <BooleanInput source="owned" defaultValue='true' label="Owned By Me" style={{ color: 'white' }} resettable />
    </Filter>
);

const groupBy = (array, groups, valueKeys) => {
  const map = new Map();
  groups = [].concat(groups);
  return array.reduce((r, o) => {
      let dataMap = groups.reduce((m, k, i, { length }) => {
          let child;
          if (m.has(o[k])) return m.get(o[k]);
          if (i + 1 === length) {
              child = Object
                  .assign(...groups.map(k => ({ [k]: o[k] })),
                    valueKeys.reduce((acc, valueKey) => {
                      acc[valueKey] = 0;
                      return acc;
                    }, {})
                  );
              r.push(child);
          } else {
              child = new Map();
          }
          m.set(o[k], child);
          return child;
      }, map);
      valueKeys.forEach(valueKey => dataMap[valueKey] += +o[valueKey]);
      return r;
  }, []);
};

const flattenData = (data) => {
  let subData = [];
  data.forEach(rec => {
    if(rec.revenue_stats.length > 0) rec.revenue_stats.forEach(stat => {
      subData.push({...stat, url: rec.url, tldomain: rec.tldomain, score: rec.score, keywords: rec.keywords});
    });
  });
  return subData;
};

const aggregateByFields = (data, fields) => {
  fields = (Array.isArray(fields) && fields.length < 1) ? '' : fields;
  return groupBy(data, fields, ['revenue', 'impressions', 'clicks']);
};

export const SegmentList = (props) => {
  const classes = useStyles(props);
  return (
    <List {...props} title="Segments" perPage={25} bulkActionButtons={false} filters={<SegmentFilter />} >
      <Datagrid rowClick="edit">
        <TextField source="code" label="ID" />
        <TextField source="name" label="Name" />
        <TextField source="bs_keywords" className={classes.truncatedList} label="Broad Keywords" />
        <TextField source="es_keywords" className={classes.truncatedList} label="Exact Keywords" />
        <BooleanField source="reporting_disabled" label="Repoting disabled" />
        <DateField source="updated_at" label="Update Date" />
        <DateField source="created_at" label="Creation Date" />
      </Datagrid>
    </List>
  );
}
let esKeywords = '';
let bsKeywords = '';
// let currentSearchType = 'match_phrase';
class CustomToolbar extends React.Component {
  state = {
  }

  constructor (props) {
    super(props);
    this.parent = props.parent;
    esKeywords = this.props.record.es_keywords;
    bsKeywords = this.props.record.bs_keywords;
    // currentSearchType = this.props.record.search_type;
  }

  fetchData () {
    this.parent.setState({ loading: true, total: '---' });
    const pathArray = []
    let url = `${BASE_URL}?`;
    if (esKeywords) pathArray.push(`es_keywords=${encodeURIComponent(esKeywords)}`);
    if (bsKeywords) pathArray.push(`bs_keywords=${encodeURIComponent(bsKeywords)}`);
    url += pathArray.join('&');
    const options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then(({ headers, json }) => {
      this.parent.setState({
        pageData: json.data,
        loading: false,
        total: json.total
      });
    });
  }

  handleSearch = (props) => {
    this.fetchData();
  }

  render () {
    return <Toolbar>
      <SaveButton style={{ marginRight: '10px' }} variant='contained' color='primary'
      disabled={this.props.parent.state.loading} {...this.props}/>
      <br />
      <Button label='Preview Pages' onClick={this.handleSearch} props={this} variant='contained' color='primary'
        startIcon={<SearchIcon />} style={{ padding: '7px', width: '160px' }}
        disabled={this.props.parent.state.loading} />
      <br />
      <DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
      <TextField source="updated_name" label="" style={{ padding: '10px' }} />
    </Toolbar>;
  }
}

function changedKeywords (source, data) {
  if (source === 'bsKeywords') { 
    bsKeywords = data;
  } else {
    esKeywords = data;
  }
}

class SegmentForm extends React.Component {
  state = {};
  render () {
    return (
      <SimpleForm toolbar={<CustomToolbar parent={this.props.parent} />} redirect='edit' {...this.props}>
        <TextField source="code" label="Segment ID" />
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <TextInput source="name" label="Segment Name" style={{ width: '400px' }} validate={required()} />
          <BooleanInput source="reporting_disabled" label="Disable reporting" initialValue={false} />
        </div>
        <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }}>
          <TextInput multiline source="bs_keywords" label="Broad Search Keywords" style={{flex: 1}}
            onChange={value => changedKeywords('bsKeywords', value.target.value)}/>
          <TextInput multiline source="es_keywords" label="Exact Search Keywords" style={{flex: 1}}
            onChange={value => changedKeywords('esKeywords', value.target.value)}/>
        </div>
      </SimpleForm>
    );
  }
}

const columns = [
  {
    name: '',
    cell: function PageButton(row) { return( <Button href={row.key} target="_blank" label="VISIT" size='small' startIcon={<LanguageIcon />}/> );},
    ignoreRowClick: true,
    allowOverflow: true,
    button: true
  },
  { name: 'Score', selector: 'avg_score', sortable: true, width: '5%', cell: function Score(row) { return(<span>{ row.avg_score.value.toFixed(2) }</span>); }},
  { name: 'Keywords', selector: 'key', sortable: true, cell: function Keywords(row) { return(<span dangerouslySetInnerHTML={{__html: row.key }}></span>); }}
];

const metricsColumns = [
  { name: 'CPM', center: true, selector: 'revenue', sortable: true, cell: (row) => <span>{ (1000*row.revenue/row.impressions || 0).toFixed(2) }</span> },
  { name: 'Impressions', selector: 'impressions', center: true, sortable: true, cell: (row) => <span>{ row.impressions }</span> },
  { name: 'Clicks', selector: 'clicks', center: true, sortable: true, cell: (row) => <span>{ row.clicks }</span> }
];

const dimensionsColumns =  [
  { name: 'Date', selector: 'timestamp', sortable: true },
  { name: 'Domain', selector: 'tldomain', sortable: true },
  { name: 'Ad Size', selector: 'adsize', sortable: true },
  { name: 'Country', selector: 'country', sortable: true, cell: (row) => <span>{ row.country }</span> },
  { name: 'Device', selector: 'device', sortable: true, cell: (row) => <span>{ row.device }</span> },
];

const revStatsColumns = (dimensions) => {
  return dimensionsColumns.filter(col => dimensions.includes(col.selector)).concat(metricsColumns);
};

const filterRevStats = (revenueStatsData, filters, dimensions) => {
  let hasActiveFilter = false;
  Object.keys(filters).forEach(filter => {
    if (filters[filter].length > 0) {
      hasActiveFilter = true;
      revenueStatsData = revenueStatsData.filter(r => filters[filter].includes(r[filter]));
    }
  });

  if (hasActiveFilter && revenueStatsData.length < 1) {
    return [{impressions: 0, clicks: 0, revenue: 0}];
  }
  return dimensions ? aggregateByFields(revenueStatsData, dimensions): revenueStatsData;
};

const getValues = (revenueStatsData, dimension) => {
  return [...new Set(revenueStatsData.map(r => ( r[dimension] )))].map(r => ({name: r, id: r}));
};

const getData = (revenueStatsData, filteredStatsData, dimensions) => {
  if (dimensions.length === 0 && filteredStatsData.length > 0) {
    return groupBy(filteredStatsData, '', ['revenue', 'impressions', 'clicks']);
  } else if (filteredStatsData.length > 0) {
    return filteredStatsData;
  } else {
    return aggregateByFields(revenueStatsData, dimensions);
  }
};

const baseFilters = {timestamp: [], tldomain: [], adsize: [], country: [], device: []};

class SegmentUpsert extends React.Component {
  state = {
    data: [],
    revenueStatsData: [],
    filteredStatsData: [],
    loading: false,
    total: '---',
    dimensions: ['timestamp'],
    filters: baseFilters
  };

  setState (obj) {
    super.setState(obj);
  }

  render (props) {
    const { data, pageData, loading, total, dimensions, filters} = this.state;
    return (
    <div>
      {this.props.formType === 'edit' &&
        <Edit title={<SegmentTitle />} {...this.props}>
          <SegmentForm formType="edit" parent={this}/>
        </Edit>
      }
      {this.props.formType === 'create' &&
        <Create title="Create Segment" {...this.props}>
          <SegmentForm formType="create" parent={this}/>
        </Create>
      }
      <DataTable
        title={`${total} Matching Pages`}
        theme="dark"
        columns={columns}
        data={pageData}
        progressPending={loading}
        pagination
        fixedHeader
        dense
        paginationPerPage={30}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        subHeader={!loading}
        subHeaderComponent={
          (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input type="text" id='search_box' label="Search"
            variant="outlined"
            style={{ margin: '5px' }}
            onChange={(target) => dataSupport.filterData(this)} />
            <CloudDownload
            label="Export"
            style={{ margin: '5px' }}
            color="action"
            onClick={() => dataSupport.exportData(this.state.data)}
            />
          </div>
          )
        }
      />
    </div>
    );
  }
}

export const SegmentEdit = (props) => (
  <SegmentUpsert formType="edit" {...props} />
);

export const SegmentCreate = (props) => (
  <SegmentUpsert formType="create" {...props} />
);
